import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getTruthAndTreasonConfig = (t: TranslateFunction): GiveawayConfig => {
  const squareImage = staticAssetUrl('v1756232981/truth-and-treason/t_t-alt-mobile.webp')
  return createBaseConfig({
    theatricalSlug: slugs.truthAndTreason,
    heroTitle: t('giveawayHeroTitleTnT', 'Walk in the Footsteps of a WWII Hero'),
    logoUrl: angelImagesUrl('v1756222214/truth-and-treason/t_t-logo.webp'),
    footerLogoUrl: angelImagesUrl('v1756222214/truth-and-treason/t_t-logo.webp'),
    inTheatersText: t('inTheatersTnT', 'In theaters October 17, 2025'),
    videoImage: angelImagesUrl('v1756232981/truth-and-treason/t_t_trailer.webp'),
    backgroundVideoUrl: '',
    share: {
      shareText:
        'The upcoming @AngelStudios movie Truth & Treason in theaters on Oct. 17th. Pre-order tickets for a chance to win the trip of a lifetime: Walk in the Footsteps of a WWII Hero!',
      hashtag: '#TruthAndTreasonGiveaway',
      shareImage: angelImagesUrl('v1756232981/truth-and-treason/t_t-alt-mobile.webp'),
      shareImageMobile: angelImagesUrl('v1756232981/truth-and-treason/t_t-alt-desktop.webp'),
    },

    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.truthAndTreason,
      congratsKey: 'truthAndTreasonCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win the trip of a lifetime: Walk in the Footsteps of a WWII Hero! Complete your checkout to secure your entries.",
      reservationKey: 'truthAndTreasonReservationCompleteText',
      reservationText:
        "You've earned entries for your chance to win the trip of a lifetime: Walk in the Footsteps of a WWII Hero!",
      noShowtimesKey: 'truthAndTreasonNowShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, pre-order tickets today for your chance to win the trip of a lifetime: Walk in the Footsteps of a WWII Hero!",
      landscapeImage: squareImage,
      portraitImage: squareImage,
    }),

    steps: [
      {
        title: t('preOrderTickets', 'Pre-Order Tickets'),
        description: t('TnTChooseYourTickets', 'Choose your tickets to Truth & Treason below.'),
      },
      {
        title: t('receiveYourPromoCodes', 'Receive Your Promo Codes'),
        description: t(
          'eachTicketEarnsAPromoCode',
          'Each ticket earns you a unique promo code (redeemable when showtimes are available).',
        ),
      },
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'theMoreTicketsYouBuy',
          'The more tickets you buy, and the earlier you buy them, the greater your entry multiplier, boosting your odds of winning!',
        ),
      },
    ],

    tabs: createStandardTabs(t),

    galleryImages: [],
    partnerLogos: [],
  })
}
